import FavoritemMenuCard from "./FavoritemMenuCard";
import RecentOrderMenuCard from "./RecentOrderMenuCard";
import NoFavoritesDiplayBoard from "./NoFavoritesDiplayBoard";
import NoRecentOrderDisplayBoard from "./NoRecentOrderDisplayBoard";
import ComboFavoritesAndRecentOrdersModal from './ComboFavoritesAndRecentOrdersModal'

export default  class ScrollingRecentOrderPage extends React.Component {
    constructor(props) {
        super(props);
        this.showCarousel = this.props.recentOrdersData != null && this.props.recentOrdersData.Orders != null && this.props.recentOrdersData.Orders.length > 1;
        this.getNotificationForFavecardUpdate = this.getNotificationForFavecardUpdate.bind(this)
        this.recentOrders = this.props.recentOrdersData;
        this.numberOfRecentFavCards = this.props.numberOfRecentFavCards;
       
        this.restaurantId = null;
    }
    scrollFavItemsCardsToTheLeft(e) {
        e.preventDefault();
        var targetContainer = $("#fav-cards-container");
        var targetPosition = targetContainer.position().left + targetContainer.width();

        var targetItem = $('#fav-cards-container .fav-orders-container').width() + 45;
        if ($(window).width() <= 1480 && $(window).width() >= 1280) {
            var targetItem = $('#fav-cards-container .fav-orders-container').width() + 47;
        }
        if (targetPosition > targetItem + 60) {
            document.getElementById('fav-item-scroll-control').scrollLeft += targetItem;
        }
    }
    scrollFavItemsCardsToTheRight(e) {
        e.preventDefault();
        var targetItem = $('#fav-cards-container .fav-orders-container').width() + 45;
        if ($(window).width() <= 1480 && $(window).width() >= 1280) {
            var targetItem = $('#fav-cards-container .fav-orders-container').width() + 47;
        }
        document.getElementById('fav-item-scroll-control').scrollLeft -= targetItem;
    }
    handleFavEnterKeyPress() {
        if (event.keyCode == 13) {
            $("#recordnone .nav-pills .recent_pill").click();
            $("#recordnone").modal('show');
        }
    }
    loadFavRecentOrderModal() {
        $("#recordnone").modal('show');
        setTimeout(function () {
            $("#recordnone .nav-pills .recent_pill").click();
        }, 500);
        
    }
    openFavModal(e) {
        e.preventDefault();
        $("#recordnone .nav-pills .fav_pill").trigger('click');
        $('#recordnone').modal('show');
    }
    

    returnFaveMenuCards(allFaveCardsData) {
        let favMenuCardSets = [];
        let topFive = []
        if (allFaveCardsData) {
            topFive = this.returnFirstFive(allFaveCardsData, 5);
            topFive.map(favData => {

                favMenuCardSets.push(
                    <div className="fav-orders-container col">
                        <FavoritemMenuCard favTitle={favData.name}
                            favProducts={favData.products}
                            buttonText={this.props.favoritesData.ReorderButtonText}
                            favId={favData.id} />
                    </div>
                )
            });
        }

        return favMenuCardSets

    }

    returnRecentOrderMenuCards(allRecentOrderCardsData, count) {
        let recentOrderMenuCardSets = [];
        let topFive = []
        if (allRecentOrderCardsData) {
            topFive = this.returnFirstFiveRecent(allRecentOrderCardsData, count);
            topFive.map(recentData => {

                recentOrderMenuCardSets.push(
                    <div className="fav-orders-container col">
                        <RecentOrderMenuCard Title={recentData.orderName}
                            recentProducts={recentData.basket.products}
                            basketId={recentData.basket.id}
                            buttonText={this.props.favoritesData.ReorderButtonText} />
                    </div>
                )
            });
        }

        return recentOrderMenuCardSets

    }

    getNotificationForFavecardUpdate() {
        var reactRefThis = this;
        $.ajax({
            method: "GET",
            url: "/api/sitecore/Menu2/UserFavorites",
        }).done(function (response) {
            var newCardSets = reactRefThis.returnFaveMenuCards(response.data)
            var finalRender = <div className="d-flex">{newCardSets}</div>

            const favCardcontainer = document.getElementById('fav-cards-container');
            const root = ReactDOM.createRoot(favCardcontainer);

            setTimeout(() => {
                root.render(finalRender);
            }, 500);

            /*setTimeout(() => {
                ReactDOM.render(finalRender,
                    document.getElementById('fav-cards-container'));
            }, 500);*/

        }).fail(function () {
            if (DE.ProgressIndicator) {
                DE.ProgressIndicator.hideIndicator();
            }
            if (DE.AlertMessageBar) {
                try {
                    var alert = {
                        AlertMessage: {},
                        RelatedItems: []
                    }
                    alert.AlertMessage.Message = "An unexpected error occurred";
                    alert.AlertMessage.Type = 3;
                    DE.AlertMessageBar.handleAlert(alert);
                } catch (e) {
                    console.log('unable to render fave card details.')
                }
            }
        });


    }

    
    
    
    returnFirstFive(favecardObjList, topFive) {
        if (topFive > favecardObjList.length) {
            return favecardObjList;
        }
        return favecardObjList
            .slice()
            .sort((a, b) => {
                return b.id - a.id
            })
            .slice(0, topFive);

    }
    returnFirstFiveRecent(recentcardObjList, topFive) {
        if (topFive > recentcardObjList.length) {
            return recentcardObjList;
        }
        return recentcardObjList
            .slice(0, topFive);

    }
    render() {
        return (
            <div className="categories-menu-page">
                <div className="menu-main-layout">
                    <div className="">
                        <div className="main-menus-container">
                            <div className="main-menus-topsection container">
                                <div className="row topmenurow">
                                        <div className="col-sm-12 col-md-12 limited-slider-section">

                                            <div className="">
                                                <div className="row">
                                                    <div className="col-sm-12 col-md-12 recent-favorite-container">
                                                        <div className="row">
                                                            <div className="col-12">
                                                            <div className="section-header">
                                                                    <div role="heading" className="h1 recent-favorite-heading" aria-level="1">
                                                                        {this.recentOrders && this.recentOrders.RecentOrdersSectionTitle}
                                                                        {(this.recentOrders && this.recentOrders.Orders && this.recentOrders.Orders.length > 0) ?
                                                                        <span className="recentorder-seeall" role="link" tabIndex="0" onClick={this.loadFavRecentOrderModal} onKeyDown={this.handleFavEnterKeyPress} >
                                                                                See all
                                                                            </span> : null
                                                                        }

                                                                    </div>
                                                                    <div className="divider"></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    <div className="fav-box">
                                                        
                                                            <div className="left-arrow-container scroll-arrow-container">
                                                                <div role="button" title="Previous" aria-label="Previous" onClick={this.scrollFavItemsCardsToTheRight} className="recentorder-leftscroll scroll-arrow scroll-arrow-left d-none d-lg-block"></div>
                                                            </div>
                                                     
                                                        
                                                        {(!this.recentOrders || !this.recentOrders.Orders || !this.recentOrders.Orders.length) ? <NoRecentOrderDisplayBoard title={this.recentOrders.NoRecentOrdersTitle}
                                                            subTitle={this.recentOrders.NoRecentOrdersSubTitle} />
                                                            :
                                                            <div id="fav-item-scroll-control" className="row">
                                                                <div id="fav-cards-container" className="fav-orders-scrollable-container" data-cardcount={this.numberOfRecentFavCards}>
                                                                    {this.returnRecentOrderMenuCards(this.recentOrders ? this.recentOrders.Orders : null, this.numberOfRecentFavCards ? this.numberOfRecentFavCards : 5)}
                                                                </div>
                                                            </div>
                                                        }
                                                       
                                                            <div className="scroll-arrow-container">
                                                            <div role="button" title="Next" aria-label="Next" onClick={this.scrollFavItemsCardsToTheLeft} className="recentorder-rightscroll scroll-arrow d-none d-lg-block"></div>
                                                            </div>
                                                       
                                                    </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                  
                                   
                                </div>
                            </div>

                            
                           
                        </div>
                    </div>
                </div>
               
                    <ComboFavoritesAndRecentOrdersModal data={this.props.favoritesData}
                        recentOrders={this.recentOrders} landingPageUrl={this.props.menuLandingPage}
                        sendNotificationForFavecardUpdate={this.getNotificationForFavecardUpdate}
                    />
            </div>
        );
    }
}
